import {
  ImageBackground,
  StyleSheet,
  useWindowDimensions,
  SafeAreaView,
  Image,
} from "react-native";
import React, { useEffect, useState } from "react";
import { StackScreenProps } from "../../types";
import {
  View,
  Text,
  Heading,
  Pressable,
  ScrollView,
  Box,
  HStack,
  Flex,
} from "native-base";
import Header from "../../components/Header";
import CountUp from "react-countup";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { RenderItem } from "../../components/RenderItem";

const slideItems = [
  {
    text: "Detailed soil survey and soil fertility mapping to enhance management of problematic soils. ",
    image: require("../../assets/vectors/survey.png"),
  },
  {
    text: "Dissemination of innovation and technologies for managing problematic soils in Nigeria.",
    image: require("../../assets/vectors/box.png"),
  },
  {
    text: "Evaluation of small-scale demonstration plots for promoting participatory evaluation of technologies and training of farmers on farmers’ fields.",
    image: require("../../assets/vectors/chart.png"),
  },
  {
    text: "Technology diffusion and sensitization of demonstration plots results for improved crop production and livelihood.",
    image: require("../../assets/vectors/plant.png"),
  },
  {
    text: "Sensitization of the private sector, financial institutions, and policymakers on the management of problematic soils.",
    image: require("../../assets/vectors/finance.png"),
  },
];

const SchoolLab = ({ navigation }: StackScreenProps<"CropResearch">) => {
  const { width, height } = useWindowDimensions();

  const [data, setData] = useState({});
  useEffect(() => {
    async function getData() {
      const items = await AsyncStorage.getItem("keyFigures");

      if (items) {
        try {
          setData(JSON.parse(items));
          // console.log(JSON.parse(items));
        } catch (error) {
          console.log(error);
        }
      }
    }

    getData();
  }, []);

  return (
    <View style={styles.container}>
      <ImageBackground
        source={require("../../assets/grains.png")}
        resizeMode="cover"
        style={{ width, height }}
      >
        <View style={styles.overlay}>
          <SafeAreaView style={{ height }}>
            <ScrollView
              px="6"
              contentContainerStyle={{
                flex: 1,
                paddingBottom: 20,
              }}
            >
              <Header
                onPress={() => navigation.navigate("FarmInitiatives")}
                parentText="Farm Initiatives"
                headingText="School Lab"
              />

              <View>
                <Text
                  textAlign="center"
                  fontWeight="bold"
                  mb={5}
                  fontFamily="Rajdhani-Bold"
                >
                  Key Figures
                </Text>

                <Box
                  // width={"5/6"}
                  // h="16"
                  mb={5}
                  margin="auto"
                  // borderBottomColor="#000"
                  borderColor={"#555"}
                  borderWidth="1"
                  borderRadius={15}
                  p={5}
                  pt={0}
                  pb={2}
                >
                  <HStack justifyContent={"space-between"}>
                    <View w={"30%"}>
                      <Text
                        fontWeight={"extrabold"}
                        fontSize="2xl"
                        fontFamily="Rajdhani-Bold"
                        textAlign={"center"}
                      >
                        <CountUp
                          delay={0}
                          end={data["schoollab_1"] / 1000}
                          suffix="k+"
                        />
                      </Text>
                      <Text
                        fontWeight={"bold"}
                        fontFamily="Rajdhani-Bold"
                        textAlign={"center"}
                      >
                        Farmers Reached
                      </Text>
                    </View>

                    <View w={"30%"}>
                      <Text
                        fontWeight={"extrabold"}
                        fontSize="2xl"
                        fontFamily="Rajdhani-Bold"
                        textAlign={"center"}
                      >
                        <CountUp delay={0} end={data["schoollab_2"]} />
                      </Text>
                      <Text
                        fontWeight={"bold"}
                        fontFamily="Rajdhani-Bold"
                        textAlign={"center"}
                      >
                        Mobile Soil Testing Trucks
                      </Text>
                    </View>
                    <View w={"30%"}>
                      <Text
                        fontWeight={"extrabold"}
                        fontSize="2xl"
                        fontFamily="Rajdhani-Bold"
                        textAlign={"center"}
                      >
                        <CountUp
                          delay={0}
                          end={data["schoollab_3"]}
                          suffix="+"
                        />
                      </Text>
                      <Text
                        fontWeight={"bold"}
                        fontFamily="Rajdhani-Bold"
                        textAlign={"center"}
                      >
                        Jobs Created
                      </Text>
                    </View>
                  </HStack>
                </Box>
              </View>

              <Text textAlign="center" mb={5} mt={10}>
                Launched in November 2017 and implemented in partnership with
                ministries of Agriculture, local institutions specialized in the
                development of agriculture, LAPO, Sterling Bank and ABU MFB.
              </Text>

              <Text textAlign="center">
                The OCP School Lab is an all-in-one mobile school and laboratory
                that moves from community to community, state to state to
                provide awareness on the importance of soil testing by providing
                demonstrations. Farmers receive necessary information about
                fertilizer use and training on agronomic best practices.
              </Text>

              <View mb={20} mt={10}>
                {/* <Swiper controlsEnabled={true}> */}
                {[
                  require("../../assets/gallery/schoollab/schoollab1.jpg"),
                  require("../../assets/gallery/schoollab/schoollab2.jpg"),
                  require("../../assets/gallery/schoollab/schoollab3.jpg"),
                  require("../../assets/gallery/schoollab/schoollab4.jpg"),
                  require("../../assets/gallery/schoollab/schoollab5.jpg"),
                  require("../../assets/gallery/schoollab/schoollab6.jpg"),
                  require("../../assets/gallery/schoollab/schoollab7.jpg"),
                ].map((item, index) => RenderItem({ item, index }))}
                {/* </Swiper> */}
              </View>

              <View mt={10}></View>
            </ScrollView>
          </SafeAreaView>
        </View>
      </ImageBackground>
    </View>
  );
};

export default SchoolLab;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  imageContainer: {
    flex: 1,
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "#923a03c7",
  },
  slideContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  slide1: {
    backgroundColor: "rgba(20,20,200,0.3)",
  },
  slide2: {
    backgroundColor: "rgba(20,200,20,0.3)",
  },
  slide3: {
    backgroundColor: "rgba(200,20,20,0.3)",
  },
});
